package site.shadadman.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initResumePage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("Resume.md", FrontMatterElement.Builder { addScalar("title", "Resume"); }))
}

@Page("/resume")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun ResumePage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("summary") }) {
        org.jetbrains.compose.web.dom.Text("Summary")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("A seasoned Android Developer with twelve years of experience. What makes this person special is he's ability to build lasting relationships, having client & colleges with 10 years of partnerships. Health tech, Digital Retail, Trading, iGaming, embedding AI models for edge computing & talking to native, are core domains of knowledge. Strong focus on improving mobile performance with Kotlin Multiplatform.")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("work-experience") }) {
        org.jetbrains.compose.web.dom.Text("Work Experience")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("senior-android-engineer-alopeyk-fulltime-onsite-aug-2026-present") }) {
        org.jetbrains.compose.web.dom.Text("Senior Android Engineer @ Alopeyk - FullTime/OnSite ----------> Aug 2026 - Present")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Delivery logistics application empowering over 10 million users and 500,000 active couriers with 300K daily orders")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Responsible for converting the single module codebase into a multi-modular feature-based architecture, improving build pipeline times")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Responsible for implementing the courier application, making a smooth experience for drivers")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Encouraged teammates to use AI on a large production scale, speeding up the dev process & releases")
        }
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("senior-android-engineer-bit24-cash-fulltime-hybrid-sept-2025-aug-2026") }) {
        org.jetbrains.compose.web.dom.Text("Senior Android Engineer @ Bit24.cash - FullTime/Hybrid ----------> Sept 2025 - Aug 2026")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Crypto exchange ecosystem with over 2 million active users")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Responsible for implementing features in a squad based team, with each squad owning a specific area")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Responsible for migrating to KMP in order to target iOS & growing our users by an unimaginable number")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Responsible for CI/CD pipelines on the KMP side using GitLab Runner for automated releases to Google Play & TestFlight.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Participating in hiring new engineers & interviews")
        }
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("kotlin-multiplatform-engineer-sportsgamex-parttime-remote-apr-2025-aug-2025") }) {
        org.jetbrains.compose.web.dom.Text("Kotlin Multiplatform Engineer @ SportsGameX - PartTime/Remote ------------> Apr 2025 - Aug 2025")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("MVI architecture combined with Precompose and Koin. Recomposition and State Management")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Integrate an on device AI model to assist users in buying/selling stocks.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Data visualization with TradingView on Android and iOS with a reusable KMP library. socker.io usage")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Firebase notification, Crashlytics, and Analytics. Kermit and Kotzila for logging.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("CI/CD pipeline with GitHub Actions for Google Play and TestFlight deployment.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Working on part of Ktor server with AWS S3 and ECS involved.")
        }
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("lead-android-developer-straiberry-fulltime-onsite-dec-2021-feb-2025") }) {
        org.jetbrains.compose.web.dom.Text("Lead Android Developer @ StrAIberry - FullTime/OnSite ------------> Dec 2021 - Feb 2025")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Leading Android team, making production decisions and deliver features with Agile.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Clean Architecture followed by a multi-module MVVM setup and TDD. CI/CD with GitLab Runner")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Integrated on-device TFLite & YOLO models, achieving 98% real-time jaw detection accuracy.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("A live tooth detection system with autofocus and zoom with camera2.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Custom calendar system for dentist appointment and brush reminder.")
        }
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("kotlin-multiplatform-engineer-marketmlm-fulltime-remote-may-2017-dec-2021") }) {
        org.jetbrains.compose.web.dom.Text("Kotlin Multiplatform Engineer @ MarketMLM - FullTime/Remote ------------> May 2017 - Dec 2021")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("An e-commerce application with a multi-role profile panel.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Good usage of Decompose, Room & Native Interoperability.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Custom server, enabling other site-owners to build their application and get a release.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Ability to customize the application based on customer details.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Launched promo webview app, raising sales 35%.")
        }
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("android-developer-arongroups-fulltime-remote-aug-2015-mar-2017") }) {
        org.jetbrains.compose.web.dom.Text("Android Developer @ AronGroups - FullTime/Remote -------------> Aug 2015 -  Mar 2017")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Implemented WebSocket trading, handling 100k+ daily transactions.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Recreate the old Java system logic with modern Kotlin approaches.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Refactor legacy code for better usage of multithreading. Reduce UI lacks by 50%.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Leading a team of three Android Developers, code review, and Agile task management.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Improving algorithms for arbitrage, Limit Orders, and Stop-Loss Orders.")
        }
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("lead-android-developer-alfatechnology-fulltime-onsite-dec-2014-jun-2015") }) {
        org.jetbrains.compose.web.dom.Text("Lead Android Developer @ AlfaTechnology - FullTime/OnSite -------------> Dec 2014 - Jun 2015")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Tracking cars with a custom GPS hardware on Google Maps with SIM telemetry.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Drawing custom polygons on Google Maps to visualize car travel distances and filtering vehicle travel.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Remotely lock, unlock, and start a car by sending commands to the GPS hardware.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Develop background alerts for vehicle events such as doors opening or impact.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Great usage of Java, Services, and good old butterknife.")
        }
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("skills") }) {
        org.jetbrains.compose.web.dom.Text("Skills")
    }
    org.jetbrains.compose.web.dom.Table {
        org.jetbrains.compose.web.dom.Thead {
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Th(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("Category")
                }
                org.jetbrains.compose.web.dom.Th(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("Technologies & Frameworks")
                }
            }
        }
        org.jetbrains.compose.web.dom.Tbody {
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.B {
                        org.jetbrains.compose.web.dom.Text("Mobile Platforms")
                    }
                }
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("Android Studio, Xcode, Kotlin, Java, Swift, Compose, CMP, XML, Kotlin Multiplatform")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.B {
                        org.jetbrains.compose.web.dom.Text("Architecture & Logic")
                    }
                }
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("Concurrency & Multithreading, Coroutines, Flow, State and Recomposition management")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.B {
                        org.jetbrains.compose.web.dom.Text("Dependency Injection")
                    }
                }
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("DI, Koin, Dagger, Hilt")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.B {
                        org.jetbrains.compose.web.dom.Text("Networking & API")
                    }
                }
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("RestAPI, Ktor, Retrofit, Ktorfit, GraphQL, Socket")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.B {
                        org.jetbrains.compose.web.dom.Text("Local Data & Offline")
                    }
                }
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("Offline first functionality, DB, Caching")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.B {
                        org.jetbrains.compose.web.dom.Text("Native & Low Level")
                    }
                }
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("NDK, JNI, C/C++, OpenCV, cinterop, Native first")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.B {
                        org.jetbrains.compose.web.dom.Text("Hardware & Location")
                    }
                }
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("BLE, Camera, Sensors, GPS, Google Map, OpenStreetMap, Interactive Mapping")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.B {
                        org.jetbrains.compose.web.dom.Text("AI & Machine Learning")
                    }
                }
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("On-device AI, TFLite, PyTorch Mobile, MediaPipe")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.B {
                        org.jetbrains.compose.web.dom.Text("Testing & Security")
                    }
                }
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("TDD, JUnit, Robolectric, Appium, Mockito, Data Protection, Security, Cryptography")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.B {
                        org.jetbrains.compose.web.dom.Text("CI/CD & DevOps")
                    }
                }
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("Jenkins, Gitlab Runner, GitHub Action, Build Systems")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.B {
                        org.jetbrains.compose.web.dom.Text("Analytics & Backend")
                    }
                }
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("Firebase, Mixpanel, Kermit, Kotzila")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.B {
                        org.jetbrains.compose.web.dom.Text("Domain Experience")
                    }
                }
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("e-commerce, Q-commerce, Digital Retail, HealthTech, Trading & iGaming")
                }
            }
        }
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("education") }) {
        org.jetbrains.compose.web.dom.Text("Education")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Software Engineering @ University of Kurdistan")
    }
}
